import { render, staticRenderFns } from "./BannersList.vue?vue&type=template&id=c7332240&scoped=true&"
import script from "./BannersList.vue?vue&type=script&lang=js&"
export * from "./BannersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7332240",
  null
  
)

export default component.exports